/*********************************************************
 * Import Third controls
 *********************************************************/
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

/*********************************************************
 * Import Controls
 *********************************************************/
import { Tabs, TabContainer } from "@gpstrackit/gtc-react-controls";
import { useIntl } from "react-intl";

import VehicleTrailsForm from "./components/VehicleTrailsForm";
import VehicleTrailsTable from "./components/VehicleTrailsTable";
import VehicleTrailsSettings from "./components/VehicleTrailsSettings";
import Settings from "../../../../.common/components/InfoBubble/.components/settings";
import { VehicleTripsMode } from "./components/vehicleTripsMode";
import { clearRedux } from 'Redux/actions';

const VehicleTrails = ({ mapRef }) => {
  const { messages } = useIntl();
  const [filter, setFilter] = useState("");
  const showVehicleTrailsTable = useSelector(
    (state) =>
      state.realtimeMapUtilitiesvehiclesTrailRedux.showVehicleTrailsTable
  );
  const showVehicleTrailsSettings = useSelector(
    (state) =>
      state.realtimeMapUtilitiesvehiclesTrailRedux.showVehicleTrailsSettings
  );

  const onClearSearchList = () => {
    setFilter("");
  };

  return (
    <>
      {showVehicleTrailsSettings && (
        <VehicleTrailsSettings messages={messages} />
      )}
      {!showVehicleTrailsSettings && !showVehicleTrailsTable && (
        <VehicleTrailsForm
          messages={messages}
          onClearSearchList={onClearSearchList}
        />
      )}
      {!showVehicleTrailsSettings && showVehicleTrailsTable && (
        <VehicleTrailsTable
          messages={messages}
          mapRef={mapRef}
          paramSetFilter={setFilter}
          paramFilter={filter}
        />
      )}
    </>
  );
};

const TrailsTripMode = ({ mapRef, onClickSettings }) => {
  const { messages } = useIntl();
  const dispatch = useDispatch();
  const { user, authenticatedId } = useSelector(state => state.securityRedux);
  const { getMarkerDetailsResponse: response } = useSelector(state => state.infoBubbleRedux);
  const { paramsVehicleTrails } = useSelector(state => state.realtimeMapUtilitiesvehiclesTrailRedux)
  const unitVehicleTrails = useSelector(state => state.vehicleTrailsSliceRedux.unitVehicleTrails);
  const defaultTab = paramsVehicleTrails?.unitId > 0 ? 1 : 0
  const [activeTab, setActiveTab] = useState(defaultTab);

  useEffect(() => {
    if (paramsVehicleTrails?.unitId) {
      setActiveTab(1);
    }
  }, [paramsVehicleTrails?.unitId]);

  return (
    <div data-testid="vehicle-trails" style={{ padding: 0 }}>
      <Tabs tab={activeTab} onChange={(event) => {
        if (event === 0) {
          // Going to Vehicle Trips: full reset of trails state
          dispatch(clearRedux("TRAILS_REDUX"));
        } else if (event === 1) {
          // Going to Vehicle Trails: clear trail data but carry over the unit selected in Vehicle Trips
          dispatch(clearRedux("TRAILS_REDUX", {
            vehicleTrails: [],
            showVehicleTrails: false,
            showVehicleTrailsTable: false,
            vehicletrailsPrint: [],
            loadVehicleTrails: false,
            paramsVehicleTrails: { limit: 100, offset: 0, total: 0 },
            unitToPrint: unitVehicleTrails || null,
          }));
        }
        setActiveTab(event);
      }}>
        <TabContainer
          label={messages.realtimemaps_vehicletrails_trips}
          index={0}
          childrenProps={{ p: 0, mt: 1 }}
          data-testid="trips-tab"
        >
          <VehicleTripsMode mapRef={mapRef} />
        </TabContainer>
        <TabContainer
          label={messages.realtimemaps_vehicletrails_trails}
          index={1}
          childrenProps={{ p: 0, mt: 1 }}
          data-testid="trails-tab"
        >
          <VehicleTrails mapRef={mapRef} />
        </TabContainer>
        <TabContainer
          label={messages.realtimemaps_vehicletrails_settings}
          index={2}
          childrenProps={{ p: 0, mt: 1 }}
          data-testid="settings-tab"
        >
          <Settings
            trailsMenu
            id={"trailsTripModeSettings"}
            user={user}
            authenticatedId={authenticatedId}
            data={response}
            hideTitle={true}
          />
        </TabContainer>
      </Tabs>
    </div>
  );
};

export default TrailsTripMode;
